import React, { Component } from 'react'
import PropTypes from 'prop-types'

import cx from 'classnames'
import { RadioGroup, Radio } from 'react-radio-group'

import { RADIO_GROUP_ORIENTATIONS } from './constants'

import './style.scss'

export default class RadioGroupComponent extends Component {
    static propTypes = {
        componentIdentifier: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
        orientation: PropTypes.string,
        radioDefinitions: PropTypes.array,
        selectedValue: PropTypes.string.isRequired,
        title: PropTypes.element.isRequired,
    }

    static defaultProps = {
        orientation: RADIO_GROUP_ORIENTATIONS.HORIZONTAL,
        radioDefinitions: [],
    }

    handleOnRadioChange = (value) => this.props.onChange(value)

    render() {
        const { selectedValue, radioDefinitions, orientation, componentIdentifier, title } = this.props

        return (
            <div className={cx('radio-group', orientation)}>
                {title}
                <RadioGroup
                    name={componentIdentifier}
                    selectedValue={selectedValue}
                    onChange={this.handleOnRadioChange}
                >
                    {radioDefinitions.map(({ value, label }, key) => (
                        <div className={'radio-wrap'} key={`radio-group-element-${key}`}>
                            <Radio value={value} />
                            <span className={'radio-label'} onClick={() => this.handleOnRadioChange(value)}>
                                {label}
                            </span>
                        </div>
                    ))}
                </RadioGroup>
            </div>
        )
    }
}
